import * as yup from 'yup'

import {userLocaleHiddenSchema} from './user'
import {emailRequired} from './utils'

export const userSignupSchema = yup.object({
  email: emailRequired,
})

export const userSignupServerSchema = yup
  .object({
    callbackUrl: yup.string().nullable(),
  })
  .concat(userLocaleHiddenSchema)
  .concat(userSignupSchema)
